/**
 * A simple event-based system to communicate between non-React services (like api.js)
 * and the React UI components (like App.jsx).
 */

const SESSION_EXPIRED_EVENT = 'app:session_expired';

export const emitSessionExpired = (reason = 'expired') => {
    const event = new CustomEvent(SESSION_EXPIRED_EVENT, { detail: { reason } });
    window.dispatchEvent(event);
};

export const subscribeToSessionExpired = (callback) => {
    const handler = (event) => callback(event.detail);
    window.addEventListener(SESSION_EXPIRED_EVENT, handler);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
};
